module.exports = __webpack_public_path__ + "static/media/status-complete.dc69cf8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/status-complete.svg
// module id = 224
// module chunks = 0